import './DetailBranch.scss'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useDispatch } from 'react-redux'
import { getDetailStock } from 'store/actionReducers/TrendStore'
import SearchInput from './SearchInput'
import iconBack from '../../../../../assets/images/StockAnalysis/icon-back.png'
import { useSelector } from 'react-redux'
import TabFilter from './TabFilter'
import { useEffect, useState } from 'react'
import useMarket from 'hook/useMarket'
import { options } from './DetailBranchConfig'
import useHelper from 'hook/useHelper'
import LabelFooter from 'components/common/Chart/LabelFooter'

export default function DetailBranch() {
  const dispatch = useDispatch()
  const CommnonStore = useSelector((state) => state?.CommnonStore)
  const TrendStore = useSelector((state) => state?.TrendStore)
  const MarketStore = useSelector((state) => state?.MarketStore)
  const [FilterLabel, setFilterLabel] = useState([])
  const { fetchCashflowIndustry, filterCashFlowIndustry } = useMarket()
  const { handleFilterArray } = useHelper();

  useEffect(() => {
    if (TrendStore?.data?.icbcode && TrendStore?.step === 'branch') {
      fetchCashflowIndustry(TrendStore?.data?.icbcode)
    }
  }, [TrendStore?.data?.icbcode])

  const handleDetailCode = (data) => {
    dispatch(getDetailStock({ step: 'code', data: data }))
  }

  // const handleBack = () => {
  //   dispatch(getDetailStock({ step: '', data: {} }))
  // }

  const handleClickFilter = (tab) => {
    dispatch(getDetailStock({ step: '', tabFilter: tab, data: {} }))
  }

  const handleChangeFilterLabel = (value) => {
    const FilterLabelNew = handleFilterArray(value, FilterLabel)
    setFilterLabel([...FilterLabelNew])
  }

  return (
    <>
      <SearchInput />
      <TabFilter tabActiveDefault={MarketStore?.marketCashflowIndustry?.category} clickFilter={(value) => handleClickFilter(value)} />
      <div className='odnikstzbm'>
        <div className='xbjjvdsfqt'>
          <div className='kccxtosxja gbuaeclvej crWGjAyNVr'>
            <div className='dqrlvqggzk ncmaxresbt'>Ngành</div>
            {/* <div className='dqrlvqggzk fvweysihdv'>Vốn hóa</div> */}
            <div className='dqrlvqggzk yjkkqkfpyp'>Cổ phiếu tích cực</div>
            <div className='dqrlvqggzk omcmnkuijs'>Cổ phiếu tiêu cực</div>
          </div>
          <div className='xizvgwhqml'>
            <div className='cavjxmogtp'>
              {
                [0].map((item, key) => {
                  return (
                    <div className='kccxtosxja elqqrpfvve' key={key}>
                      <div className='dqrlvqggzk ncmaxresbt'>{MarketStore?.marketCashflowIndustry?.icbname}</div>
                      {/* <div className='dqrlvqggzk fvweysihdv'>4.62</div> */}
                      <div className='dqrlvqggzk yjkkqkfpyp'>
                        {
                          MarketStore?.marketCashflowIndustry?.stockPositive && MarketStore?.marketCashflowIndustry?.stockPositive.length > 0 ?
                            MarketStore?.marketCashflowIndustry?.stockPositive.map((item2, key2) => {
                              return (
                                <span className='fpqptzczsq' key={key2} onClick={() => handleDetailCode({ stock: item2 })}>
                                  {item2}{MarketStore?.marketCashflowIndustry?.stockPositive.length - 1 > key2 && MarketStore?.marketCashflowIndustry?.stockPositive.length > 0 && `,`}
                                </span>
                              )
                            }) : null
                        }
                      </div>
                      <div className='dqrlvqggzk omcmnkuijs'>
                        {
                          MarketStore?.marketCashflowIndustry?.stockNegative && MarketStore?.marketCashflowIndustry?.stockNegative.length > 0 ?
                            MarketStore?.marketCashflowIndustry?.stockNegative.map((item2, key2) => {
                              return (
                                <span className='fpqptzczsq' key={key2} onClick={() => handleDetailCode({ stock: item2 })}>
                                  {item2}{MarketStore?.marketCashflowIndustry?.stockNegative.length - 1 > key2 && MarketStore?.marketCashflowIndustry?.stockNegative.length > 0 && `,`}
                                </span>
                              )
                            }) : null
                        }
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className='oljolmldcu'>
          <div className='hayvdmtnvu'>
            <div className="awopotuuhp">
              {
                MarketStore?.marketCashflowIndustry ? <HighchartsReact
                  highcharts={Highcharts}
                  options={options(filterCashFlowIndustry(MarketStore?.marketCashflowIndustry), FilterLabel, CommnonStore)}
                /> : null
              }

            </div>
            <div className='nxcbyjafuq'>Hồi phục</div>
            <div className='jlhsvdrypk'>Tăng mạnh</div>
            <div className='bcexoqlpqp'>Giảm mạnh</div>
            <div className='bdixkxbncj'>Suy yếu</div>
            {/* <div className='klPybDJriH' onClick={() => handleBack()}><img src={iconBack} alt='' className='SaKCuJJtHX' /></div> */}
          </div>
          <LabelFooter selectData={(value) => handleChangeFilterLabel(value)}
            listDefault={FilterLabel}
            data={[
              { name: 'Hồi phục', color: '#2ad03d' },
              { name: 'Tăng mạnh', color: '#9b51e0' },
              { name: 'Giảm mạnh', color: '#e31e4d' },
              { name: 'Suy yếu', color: '#f7931a' },
              { name: 'Ngành', color: '#FFEA8B' },
            ]} />
        </div>
      </div>
    </>
  )
}